// src/components/PsicomotricidadeInfo.tsx
import React from 'react';
import '../../styles/especialidades.css';

const NeurologistaInfo: React.FC = () => (
    <section className="about_psicomotricidade">
        <div className="teste_zoom_two">
            <div className="about_text_psicomotricidade">
                <h2 className='sub_title'><b>Autenticidade, escuta e transformação.</b></h2>
                <br />
                <p>A Psicologia Humanista é uma abordagem terapêutica centrada na singularidade de cada indivíduo, valorizando sua liberdade, responsabilidade e capacidade inata de crescimento. Em vez de focar exclusivamente em sintomas ou diagnósticos, essa linha da psicologia se dedica a compreender a experiência subjetiva da pessoa, promovendo o autoconhecimento, a autenticidade e o desenvolvimento do potencial humano.</p>
                <br />
                <p>O processo terapêutico se baseia em uma relação de empatia, escuta genuína e aceitação incondicional. O psicólogo humanista não se coloca como um “sabe-tudo”, mas como um facilitador, que acompanha o cliente em seu próprio ritmo, respeitando sua história, valores e escolhas.</p>
                <br />
                <p>Por meio dessa escuta acolhedora e não julgadora, situações como crises existenciais, baixa autoestima, conflitos internos, ansiedade ou dificuldades de relacionamento são abordadas com sensibilidade e profundidade, favorecendo a reconexão da pessoa consigo mesma e com sua essência.</p>
                <br />
                <p><b>Quando procurar a Psicologia Humanista?</b></p>
                <br />
                <p>A Psicologia Humanista é indicada para:</p>
                <br />

                    <li>Indivíduos que buscam compreender suas emoções e desenvolver sua autonomia emocional;</li>
                    <li>Pessoas em momentos de transição, como mudanças de carreira, término de relacionamentos ou busca de propósito;</li>
                    <li>Adolescentes e jovens adultos em processo de construção da identidade;</li>
                    <li>Quem deseja ser ouvido em profundidade, sem rótulos ou julgamentos, com respeito à sua história e subjetividade.</li>
                
                <br />
                <p><b>Espaço para ser quem você é</b></p>
                <br />
                <p>A Psicologia Humanista acredita que cada pessoa é capaz de se tornar a melhor versão de si mesma, quando encontra um espaço seguro, respeitoso e autêntico para se expressar e se transformar. Nesse sentido, o trabalho terapêutico torna-se um caminho de reconexão com os próprios valores, desejos e potencialidades.</p>

            </div>
        </div>
    </section>
);

export default NeurologistaInfo;